import { type OutlinedTextFieldProps as MuiOutlinedTextFieldProps, TextField as MuiTextField } from '@mui/material';

import type { WithoutStyleOverrides } from '../../../types/WithoutStyleOverrides';
import { FormHelperText } from '../../atoms/FormHelperText';
import { Input } from '../../atoms/Input';

type Props = WithoutStyleOverrides<
  Omit<
    MuiOutlinedTextFieldProps,
    | 'variant'
    | 'select'
    | 'SelectProps'
    | 'children'
    | 'margin'
    | 'slots'
    | 'InputProps'
    | 'inputProps'
    | 'InputLabelProps'
    | 'FormHelperTextProps'
  >
>;

const SLOTS = { input: Input, formHelperText: FormHelperText };

export function TextField(props: Props) {
  return <MuiTextField {...props} variant="outlined" slots={SLOTS} />;
}

export type { Props as TextFieldProps };
